// // frontend/src/pages/ComplaintDrafts.js

// import React, { useEffect, useRef, useState } from "react";
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import Navbar from "../components/Navbar";
// import "../styles/ComplaintDrafts.css";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";

// const ComplaintDrafts = () => {
//     const { state } = useLocation();
//     const { query, summary, country, state: userState, lawCategory } = state || {};

//     const [policeDraft, setPoliceDraft] = useState("");
//     const [courtDraft, setCourtDraft] = useState("");
//     const [loading, setLoading] = useState(true);

//     const policeRef = useRef(null);
//     const courtRef = useRef(null);

//     useEffect(() => {
//         const fetchDrafts = async () => {
//             try {
//                 const response = await axios.post("/api/drafts/generate", {
//                     query,
//                     summary,
//                     country,
//                     state: userState,
//                     lawCategory,
//                 });

//                 const drafts = response.data.drafts;

//                 // Extract cleanly using index
//                 const policeIndex = drafts.indexOf("Police Station Complaint Draft");
//                 const courtIndex = drafts.indexOf("Court/Department Complaint Draft");

//                 if (policeIndex !== -1 && courtIndex !== -1) {
//                     const policeRaw = drafts.substring(policeIndex, courtIndex).trim();
//                     const courtRaw = drafts.substring(courtIndex).trim();

//                     // Remove repeated headings from content
//                     const cleanedPolice = policeRaw.replace(/Police Station Complaint Draft/gi, "").trim();
//                     const cleanedCourt = courtRaw.replace(/Court\/Department Complaint Draft/gi, "").trim();

//                     setPoliceDraft(cleanedPolice);
//                     setCourtDraft(cleanedCourt);
//                 } else {
//                     setPoliceDraft("Failed to extract drafts correctly.");
//                     setCourtDraft("Failed to extract drafts correctly.");
//                 }
//             } catch (err) {
//                 setPoliceDraft("Failed to generate drafts.");
//                 setCourtDraft("Failed to generate drafts.");
//                 console.error(err);
//             } finally {
//                 setLoading(false);
//             }
//         };


//         fetchDrafts();
//     }, [query, summary, country, userState, lawCategory]);


//     const formatEditableDrafts = (text, section) => {
//         return text
//             .replace(/\*\*/g, "")
//             .split(/\n{2,}/)
//             .map((para, idx) => {
//                 const trimmed = para.trim();

//                 if (/^#{1,6}\s/.test(trimmed)) {
//                     const level = trimmed.match(/^#+/)[0].length;
//                     const content = trimmed.replace(/^#+\s*/, "");
//                     const safeLevel = Math.min(level, 4);
//                     const Tag = `h${safeLevel}`;
//                     return (
//                         <Tag
//                             key={`${section}-heading-${idx}`}
//                             contentEditable
//                             suppressContentEditableWarning
//                             className="editable-heading"
//                         >
//                             {content}
//                         </Tag>
//                     );
//                 }

//                 // Break multiline lines within a paragraph to simulate vertical address lines
//                 const lines = trimmed.split("\n");
//                 return (
//                     <p
//                         key={`${section}-para-${idx}`}
//                         contentEditable
//                         suppressContentEditableWarning
//                         className="editable-paragraph"
//                     >
//                         {lines.map((line, lineIdx) => (
//                             <React.Fragment key={lineIdx}>
//                                 {line}
//                                 <br />
//                             </React.Fragment>
//                         ))}
//                     </p>
//                 );
//             });
//     };


//     const generatePDF = async (ref, fileName) => {
//         const canvas = await html2canvas(ref.current);
//         const imgData = canvas.toDataURL("image/png");
//         const pdf = new jsPDF("p", "mm", "a4");

//         const pdfWidth = pdf.internal.pageSize.getWidth();
//         const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

//         pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
//         pdf.save(fileName);
//     };

//     const handleCopyText = (ref) => {
//         const text = ref.current.innerText;
//         navigator.clipboard.writeText(text).then(() => {
//             alert("Text copied to clipboard!");
//         });
//     };

//     const handlePrint = (ref) => {
//         const printWindow = window.open("", "_blank");
//         printWindow.document.write(`
//       <html>
//         <head><title>Print Draft</title></head>
//         <body>${ref.current.innerHTML}</body>
//       </html>
//     `);
//         printWindow.document.close();
//         printWindow.focus();
//         printWindow.print();
//     };

//     const handleShare = (title) => {
//         const shareData = {
//             title,
//             text: `Here is the ${title}.`,
//             url: window.location.href,
//         };

//         if (navigator.share) {
//             navigator.share(shareData).catch((err) => console.error("Share failed:", err));
//         } else {
//             navigator.clipboard.writeText(window.location.href);
//             alert("Share link copied to clipboard!");
//         }
//     };

//     return (
//         <div className="drafts-page">
//             <Navbar />
//             <div className="drafts-container">
//                 <h1>Complaint Drafts</h1>
//                 <h3>Query: {query}</h3>
//                 <h4>Law Category: {lawCategory}</h4>

//                 {loading ? (
//                     <p className="loading-message">Generating drafts...</p>
//                 ) : (
//                     <>
//                         <div className="complaint-section" ref={policeRef}>
//                             <h2>Police Station Complaint Draft</h2>
//                             <p className="editable-note">✏️ This is an editable draft. Click on any text to modify names, dates, or places.</p>
//                             {formatEditableDrafts(policeDraft, "police")}
//                         </div>

//                         <div className="download-buttons">
//                             <button onClick={() => generatePDF(policeRef, "police_draft.pdf")} className="download-btn">Download PDF</button>
//                             <button onClick={() => handlePrint(policeRef)} className="download-btn">Print</button>
//                             <button onClick={() => handleCopyText(policeRef)} className="download-btn">Copy Text</button>
//                             <button onClick={() => handleShare("Police Complaint Draft")} className="download-btn">Share</button>
//                         </div>

//                         {/* Court Section */}
//                         <div className="complaint-section" ref={courtRef}>
//                             <h2>Court/Department Complaint Draft</h2>
//                             {formatEditableDrafts(courtDraft, "court")}
//                         </div>
//                         <div className="download-buttons">
//                             <button onClick={() => generatePDF(courtRef, "court_draft.pdf")} className="download-btn">Download PDF</button>
//                             <button onClick={() => handlePrint(courtRef)} className="download-btn">Print</button>
//                             <button onClick={() => handleCopyText(courtRef)} className="download-btn">Copy Text</button>
//                             <button onClick={() => handleShare("Court Complaint Draft")} className="download-btn">Share</button>
//                         </div>
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default ComplaintDrafts;




// frontend/src/pages/ComplaintDrafts.js

import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
// Removed: import Navbar from "../components/Navbar";
import "../styles/ComplaintDrafts.css";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

// Only show Police and Department complaint drafts on this page.

const ComplaintDraftsDisplay = () => {
  const { state } = useLocation();
  const { query, summary, country, state: userState, lawCategory, draftType, suggestionDraft } = state || {};

  // Debug logging for received state
  console.log("Received location state:", state);
  console.log("Extracted values:", { query, summary, country, userState, lawCategory, draftType });

  // Safety check and defaults
  const safeCountry = country || "India";
  const safeLawCategory = lawCategory || "Criminal Law";
  
  console.log("Using safe values:", { safeCountry, safeLawCategory });

  const [policeDraft, setPoliceDraft] = useState("");
  const [departmentDraft, setDepartmentDraft] = useState("");
  const [loading, setLoading] = useState(true);

  const policeRef = useRef(null);
  const departmentRef = useRef(null);

  const formatEditableDrafts = (text, section) => {
    return text
      .replace(/\*\*/g, "")
      .split(/\n{2,}/)
      .map((para, idx) => {
        const trimmed = para.trim();

        if (/^#{1,6}\s/.test(trimmed)) {
          const level = trimmed.match(/^#+/)[0].length;
          const content = trimmed.replace(/^#+\s*/, "");
          const safeLevel = Math.min(level, 4);
          const Tag = `h${safeLevel}`;
          return (
            <Tag
              key={`${section}-heading-${idx}`}
              contentEditable
              suppressContentEditableWarning
              className="editable-heading editable-content"
            >
              {content}
            </Tag>
          );
        }

        // Break multiline lines within a paragraph to simulate vertical address lines
        const lines = trimmed.split("\n");
        return (
          <p
            key={`${section}-para-${idx}`}
            contentEditable
            suppressContentEditableWarning
            className="editable-paragraph editable-content"
          >
            {lines.map((line, lineIdx) => (
              <React.Fragment key={lineIdx}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        );
      });
  };

  useEffect(() => {
    // If suggestionDraft is present (from DraftCreatePage), use it directly
    if (suggestionDraft && draftType) {
      setLoading(false);
      if (draftType === "police") {
        setPoliceDraft(suggestionDraft);
        setDepartmentDraft("");
      } else if (draftType === "department") {
        setDepartmentDraft(suggestionDraft);
        setPoliceDraft("");
      }
      return;
    }

    // If no query or summary, do not fetch
    if (!query && !summary) {
      setLoading(false);
      setPoliceDraft("No input provided.");
      setDepartmentDraft("");
      return;
    }

    const fetchDrafts = async () => {
      setLoading(true);
      try {
        const requestData = {
          query: query || summary,
          summary: summary || query,
          country: safeCountry,
          state: userState,
          lawCategory: safeLawCategory,
        };
        
        // Debug logging
        console.log("Sending request data:", requestData);
        console.log("Validation check:");
        console.log("- query:", requestData.query ? "✓" : "✗ (missing/empty)");
        console.log("- summary:", requestData.summary ? "✓" : "✗ (missing/empty)");
        console.log("- country:", requestData.country ? "✓" : "✗ (missing/empty)");
        console.log("- lawCategory:", requestData.lawCategory ? "✓" : "✗ (missing/empty)");

        const response = await axios.post("/api/drafts/generate", requestData);

        const drafts = response.data.drafts;

        // Extract police and department drafts only
        const policeIndex = drafts.indexOf("Police Station Complaint Draft");
        const departmentIndex = drafts.indexOf("Court/Department Complaint Draft");

        if (policeIndex !== -1 && departmentIndex !== -1) {
          const policeRaw = drafts.substring(policeIndex, departmentIndex).trim();
          const departmentRaw = drafts.substring(departmentIndex).trim();

          const cleanedPolice = policeRaw.replace(/Police Station Complaint Draft/gi, "").trim();
          const cleanedDepartment = departmentRaw.replace(/Court\/Department Complaint Draft/gi, "").trim();

          setPoliceDraft(cleanedPolice);
          setDepartmentDraft(cleanedDepartment);
        } else {
          setPoliceDraft("Failed to extract drafts correctly.");
          setDepartmentDraft("Failed to extract drafts correctly.");
        }
      } catch (err) {
        setPoliceDraft("Failed to generate drafts.");
        setDepartmentDraft("Failed to generate drafts.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDrafts();
  }, [query, summary, country, userState, lawCategory, draftType, suggestionDraft]);

  const generatePDF = async (ref, fileName) => {
    const element = ref.current;
    
    // Hide buttons and editable indicators before PDF generation
    const buttons = element.querySelectorAll('.download-buttons');
    const editableElements = element.querySelectorAll('[contenteditable]');
    const complaintSections = element.querySelectorAll('.complaint-section');
    
    // Store original states
    const originalButtonStyles = Array.from(buttons).map(btn => btn.style.display);
    const originalEditableStates = Array.from(editableElements).map(el => el.contentEditable);
    const originalBorders = Array.from(editableElements).map(el => el.style.border);
    const originalOutlines = Array.from(editableElements).map(el => el.style.outline);
    const originalBoxShadows = Array.from(editableElements).map(el => el.style.boxShadow);
    
    // Hide buttons and remove contentEditable visual indicators
    buttons.forEach(btn => btn.style.display = 'none');
    editableElements.forEach(el => {
      el.contentEditable = 'false';
      el.style.border = 'none';
      el.style.outline = 'none';
      el.style.boxShadow = 'none';
      el.style.background = 'transparent';
      el.removeAttribute('contenteditable');
    });
    
    // Inject very aggressive CSS to completely remove pseudo-element
    const tempStyle = document.createElement('style');
    tempStyle.id = 'pdf-hide-editable';
    tempStyle.innerHTML = `
      .complaint-section::after,
      .complaint-section::before,
      .complaint-section:hover::after,
      .complaint-section:hover::before {
        content: none !important;
        display: none !important;
        opacity: 0 !important;
        visibility: hidden !important;
        position: absolute !important;
        top: -9999px !important;
        left: -9999px !important;
        width: 0 !important;
        height: 0 !important;
        font-size: 0 !important;
        color: transparent !important;
        background: transparent !important;
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        text-shadow: none !important;
        z-index: -9999 !important;
      }
      
      /* Additional safety - target all possible states */
      .complaint-section *::after,
      .complaint-section *::before {
        content: none !important;
        display: none !important;
      }
    `;
    document.head.appendChild(tempStyle);
    
    // Force reflow to ensure styles are applied
    // eslint-disable-next-line no-unused-expressions
    element.offsetHeight;
    
    try {
      // Wait a moment for styles to apply
      await new Promise(resolve => setTimeout(resolve, 200));
      
      const canvas = await html2canvas(element, {
        scale: 2, // Higher resolution
        useCORS: true,
        allowTaint: true,
        height: element.scrollHeight,
        width: element.scrollWidth
      });
      
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      
      // Calculate the ratio to fit content width to PDF width
      const ratio = pdfWidth / (canvasWidth / 2); // Divide by 2 due to scale: 2
      const scaledHeight = (canvasHeight / 2) * ratio; // Divide by 2 due to scale: 2
      
      // If content fits on one page, add it directly
      if (scaledHeight <= pdfHeight) {
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, scaledHeight);
      } else {
        // Content exceeds one page, split into multiple pages
        let yPosition = 0;
        let pageIndex = 0;
        
        while (yPosition < scaledHeight) {
          if (pageIndex > 0) {
            pdf.addPage();
          }
          
          // Calculate how much content fits on current page
          const remainingHeight = scaledHeight - yPosition;
          const currentPageHeight = Math.min(pdfHeight, remainingHeight);
          
          // Add the portion of image that fits on current page
          pdf.addImage(
            imgData, 
            "PNG", 
            0, 
            -yPosition, // Negative to show different part of image
            pdfWidth, 
            scaledHeight
          );
          
          yPosition += pdfHeight;
          pageIndex++;
        }
      }
      
      pdf.save(fileName);
    } finally {
      // Restore original states
      buttons.forEach((btn, index) => btn.style.display = originalButtonStyles[index]);
      editableElements.forEach((el, index) => {
        el.contentEditable = originalEditableStates[index];
        el.style.border = originalBorders[index];
        el.style.outline = originalOutlines[index];
        el.style.boxShadow = originalBoxShadows[index];
        el.setAttribute('contenteditable', originalEditableStates[index]);
      });
      
      // Remove the temporary style element
      const tempStyleElement = document.getElementById('pdf-hide-editable');
      if (tempStyleElement && tempStyleElement.parentNode) {
        tempStyleElement.parentNode.removeChild(tempStyleElement);
      }
    }
  };

  const handleCopyText = (ref) => {
    const text = ref.current.innerText;
    navigator.clipboard.writeText(text).then(() => {
      alert("Text copied to clipboard!");
    });
  };

  const handlePrint = (ref) => {
    const element = ref.current;
    
    // Create a clean version of the content for printing
    const clonedElement = element.cloneNode(true);
    
    // Remove buttons and contentEditable from cloned element
    const buttons = clonedElement.querySelectorAll('.download-buttons');
    const editableElements = clonedElement.querySelectorAll('[contenteditable]');
    const complaintSections = clonedElement.querySelectorAll('.complaint-section');
    
    buttons.forEach(btn => btn.remove());
    editableElements.forEach(el => {
      el.removeAttribute('contenteditable');
      el.style.border = 'none';
      el.style.outline = 'none';
      el.style.boxShadow = 'none';
      el.style.background = 'transparent';
    });
    
    // Add class to hide "Editable" pseudo-element
    complaintSections.forEach(section => {
      section.classList.add('print-mode');
    });
    
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Draft</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            h1, h2, h3, h4 { color: #333; }
            p { line-height: 1.6; margin-bottom: 10px; }
            .download-buttons { display: none !important; }
            [contenteditable] { 
              border: none !important; 
              outline: none !important; 
              box-shadow: none !important;
              background: transparent !important;
            }
            /* Hide the "Editable" pseudo-element */
            .print-mode::after,
            .complaint-section::after {
              display: none !important;
            }
          </style>
        </head>
        <body>${clonedElement.innerHTML}</body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const handleShare = (title) => {
    const shareData = {
      title,
      text: `Here is the ${title}.`,
      url: window.location.href,
    };

    if (navigator.share) {
      navigator.share(shareData).catch((err) => console.error("Share failed:", err));
    } else {
      navigator.clipboard.writeText(window.location.href);
      alert("Share link copied to clipboard!");
    }
  };

  return (
    <div className="drafts-page">
      {/* Removed page-level <Navbar /> to avoid duplication; App.js already provides it */}
      <div className="drafts-container">
        <h1>Complaint Drafts</h1>
        <h3>Query: {query}</h3>
        <h4>Law Category: {lawCategory}</h4>

        {loading ? (
          <p className="loading-message">Generating drafts...</p>
        ) : (
          <>
            {policeDraft && (
              <div className="complaint-section" ref={policeRef}>
                <h2>Police Station Complaint</h2>
                {formatEditableDrafts(policeDraft, "police")}
                <div className="download-buttons">
                  <button onClick={() => generatePDF(policeRef, "police_draft.pdf")} className="download-btn">Download PDF</button>
                  <button onClick={() => handlePrint(policeRef)} className="download-btn">Print</button>
                  <button onClick={() => handleCopyText(policeRef)} className="download-btn">Copy Text</button>
                  <button onClick={() => handleShare("Police Complaint Draft")} className="download-btn">Share</button>
                </div>
              </div>
            )}

            {departmentDraft && (
              <div className="complaint-section" ref={departmentRef}>
                <h2>Department Complaint</h2>
                {formatEditableDrafts(departmentDraft, "department")}
                <div className="download-buttons">
                  <button onClick={() => generatePDF(departmentRef, "department_draft.pdf")} className="download-btn">Download PDF</button>
                  <button onClick={() => handlePrint(departmentRef)} className="download-btn">Print</button>
                  <button onClick={() => handleCopyText(departmentRef)} className="download-btn">Copy Text</button>
                  <button onClick={() => handleShare("Department Complaint Draft")} className="download-btn">Share</button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ComplaintDraftsDisplay;
